// client/globals/enums.ts
var GlobalContextName = /* @__PURE__ */ ((GlobalContextName2) => {
  GlobalContextName2["EXTENSIONS"] = "extensions";
  GlobalContextName2["CONTENT"] = "content";
  GlobalContextName2["MODE"] = "mode";
  GlobalContextName2["EDIT_CONTENT"] = "edit_content";
  GlobalContextName2["DRAGGING"] = "dragging";
  return GlobalContextName2;
})(GlobalContextName || {});
var ExtensionType = /* @__PURE__ */ ((ExtensionType2) => {
  ExtensionType2["CONTENT"] = "content";
  ExtensionType2["DOCUMENT"] = "document";
  ExtensionType2["CUSTOM_CONTENT"] = "custom-content";
  return ExtensionType2;
})(ExtensionType || {});
var Droppable = /* @__PURE__ */ ((Droppable2) => {
  Droppable2["EXTENSION"] = "extension";
  Droppable2["CLIPBOARD"] = "clipboard";
  Droppable2["EXISTING_CONTENT"] = "existing-content";
  Droppable2["CUSTOM_CONTENT_TEMPLATE"] = "custom-content-template";
  Droppable2["CUSTOM_CONTENT_REFERENCE"] = "custom-content-reference";
  return Droppable2;
})(Droppable || {});
var Size = /* @__PURE__ */ ((Size2) => {
  Size2["MOBILE"] = "mobile";
  Size2["TABLET"] = "tablet";
  Size2["DESKTOP"] = "desktop";
  return Size2;
})(Size || {});
var Contexts = /* @__PURE__ */ ((Contexts2) => {
  Contexts2["PREVIEW"] = "preview";
  Contexts2["EXTENSIONS"] = "extensions";
  Contexts2["DOCUMENT_EXTENSION"] = "document-extension";
  Contexts2["DRAGGING"] = "dragging";
  Contexts2["EDIT_CONTENT"] = "edit-content";
  Contexts2["CONTENT"] = "content";
  Contexts2["IDENTIFIER"] = "identifier";
  Contexts2["CLIPBOARD"] = "clipboard";
  Contexts2["SIZE"] = "size";
  Contexts2["HIDE_CUSTOM_COMPONENT_ID"] = "hide-custom-component-id";
  Contexts2["IS_EDITOR"] = "is-editor";
  Contexts2["SIZE_BREAKPOINT"] = "size-breakpoint";
  Contexts2["FORM"] = "form";
  Contexts2["MODE"] = "mode";
  Contexts2["OPTIONS"] = "options";
  Contexts2["AUTO_SCROLL_CONTAINER"] = "auto-scroll-container";
  Contexts2["CUSTOM_CONTENT"] = "custom-content";
  Contexts2["GLOBAL_SETTINGS_CLASS_NAME"] = "global-settings-class-name";
  Contexts2["ANCHOR_ID"] = "anchor-id";
  return Contexts2;
})(Contexts || {});
var Event = /* @__PURE__ */ ((Event2) => {
  Event2["SET_EDIT_CONTENT"] = "set-edit-content";
  Event2["SET_CONTENT"] = "set-content";
  Event2["UPDATE_CONTENT"] = "update-content";
  Event2["DRAGGING_CHANGED"] = "dragging-changed";
  Event2["COPY_TO_CLIPBOARD"] = "copy-to-clipboard";
  Event2["SIZE_CHANGED"] = "size-changed";
  Event2["OPEN_SETTINGS"] = "open-settings";
  Event2["MOVE_TO_ANCHOR"] = "move-to-anchor";
  return Event2;
})(Event || {});
export {
  Contexts,
  Droppable,
  Event,
  ExtensionType,
  GlobalContextName,
  Size
};
